import type { FaireProductEntity } from "../../entity_types/product";

export const p_qpe3zs8e4s: FaireProductEntity = {
  token: "p_qpe3zs8e4s",
  type: "product",
  name: "Lazy Sunday Soy Candle - Happy Place Collection",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/40167c730076c541b2e50b6ffda73628f517a055df8c110786b9deaf50d43fd1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0ed2d6336e2914b07ad17a1eef0a682216e1f90cc79c94654b495ea027a0ecf.jpeg",
    "https://cdn.faire.com/fastly/989bc3f0d548f2f5a1eb0970f3a47ec37b40c513a89c678eae20a9073953d2c1.jpeg",
    "https://cdn.faire.com/fastly/d1fe91587cd6337d5c0b31e024556755bf7a06686eb743eed7371ab1b0999e9d.jpeg",
  ],
  priceDollars: 13,
  description:
    "Lazy Sunday scent notes: Black Tea, Citrus, Peach & Amber\n\nMeet the Happy Place Collection: a cheerful collection that aims to bring you nostalgic joy, capturing the essence of the places that define you. Like the warm fuzzies in a candle. Where’s your happy place?\n\nDiameter: 3 in\nHeight: 3 in\nApprox. Net Wt: 7 oz \nApprox. Burn time: 40+ hours\nPhthalate Free\nMade in USA\n\nGood & Well Supply Co. crafts clean candles that celebrate the human connection with nature and inspire exploration. We donate 1% of our annual revenue to nonprofit organizations that protect and conserve national parks and public lands and promote inclusion in the outdoors.\n\nTESTER POLICY:\nLimited to one tester per scent. Testers are 2-oz candles with an easy-to-remove lid for in-store smelling.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:57.301Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
